export const ScreenSize = {
	phone: 550,
	tablet: 800
};
